exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".highscores{min-height:800px}.highscores h2{text-align:center}.highscores table{text-align:left}.lastScore table{border-collapse:collapse}.lastScore .score{cursor:pointer}.lastScore .score.selected{background-color:#7fff00}.lastScore td{padding:2px}.lastScore .record{cursor:pointer}.ranking{font-size:20px;margin:auto;width:360px}.ranking td:first-child{max-width:156px}.ranking th:nth-child(2){min-width:70px}.ranking th:nth-child(3){min-width:120px}.ranking td.score{padding:5px 15px}.ranking td{word-wrap:break-word}@media (min-width:700px){.lastBoard,.lastScore{padding:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./styles/modules/highscore.scss
// module id = 301
// module chunks = 0